





































































































































import {SERVER_HOST_QR} from "@/config";
import {Component, Prop, Vue, Watch} from 'vue-property-decorator'
import { namespace } from 'vuex-class'
import Tooltip from '@/components/UI/Tooltip.vue';
import INotes from '@/components/icons/INotes.vue'
import ISurveyNew from '@/components/icons/ISurveyNew.vue'
import IFire from '@/components/icons/IFire.vue'
import IUpload from '@/components/icons/IExport.vue'
import IArchive from '@/components/icons/IArchive.vue'
import IRestore from '@/components/icons/IRestore.vue'
import IArrow from '@/components/icons/IArrow.vue'
import IMiniNotes from '@/components/lfs/NewShardList/icons/IMiniNotes.vue'
import IMiniSurvey from '@/components/lfs/NewShardList/icons/IMiniSurvey.vue'
import {debounce} from "lodash";
import {checkContour} from "@/helpers/checkContour";

const newshards = namespace('newshards')
const profileStore = namespace('profile')
const survey = namespace('survey')
@Component({
  components: {
    Tooltip,
    'i-notes': INotes,
    'i-survey-new': ISurveyNew,
    'i-fire': IFire,
    'i-upload': IUpload,
    'i-archive': IArchive,
    'i-restore': IRestore,
    'i-arrow': IArrow,
    'i-mini-notes': IMiniNotes,
    'i-mini-survey': IMiniSurvey,
  }
})
export default class ShardListTable extends Vue {

  server:string = SERVER_HOST_QR

  @newshards.Action('loadShardsFromServer') protected loadShardsFromServer:any
  @newshards.Action('loadShardsFromServerWithQuery') protected loadShardsFromServerWithQuery: any
  @survey.Action('loadSurveyFromServer') protected loadSurveyFromServer: any

  @newshards.Getter('shards') protected shards: any
  @newshards.Getter('GetFilterShards') protected GetFilterShards: any
  @newshards.Getter('count') protected count: any
  @newshards.Getter('loading') protected loading: any

  @newshards.Mutation('setOptionsTable') protected setOptionsTable: any
  @newshards.Mutation('setOptionsTableDefault') protected setOptionsTableDefault: any

  @profileStore.Getter('plan') protected plan: any

  @profileStore.Getter('profilesMap') protected profiles: any
  @Prop({type: [Boolean], default: false}) protected isSelectedShard!: boolean
  @Prop({type: [Boolean], default: false}) protected isArchive!: boolean
  @Prop({type: [String], default: ""}) protected selectedId!: boolean
  @Prop({type: Boolean, default: false}) protected updateFilter!: boolean
  @Prop({type: Boolean, default: false}) protected disabledTable!: boolean

  get headers(){
    return [
      {text: this.$t('newShardList.table.name'), sortable: true, value: 'title'},
      {text: this.$t('newShardList.table.media'), sortable: false, value: 'dataSources',width: '150'},
      {text: this.$t('newShardList.table.date'), sortable: true, value: 'createdAtTimestamp', width: '200'},
      {text: this.$t('newShardList.table.dateUp'), sortable: true, value: 'updatedAtTimestamp', width: '200'},
      {text: '', sortable: false, value: 'mediaAttachmentsCount', width: '55'},
      {text: '', sortable: false, value: 'surveyCount', width: '55'},
      {text: this.$t('newShardList.table.whoAdded'), sortable: true, value: 'authorName',width: '200'},
      {text: this.$t('newShardList.table.category'), sortable: false, value: 'tag', width: '100'},
      {text: this.$t('newShardList.table.interest'), sortable: false, value: 'fire'},
      {text: '', sortable: false, value: 'btn', width: '68'}
    ]
  }
  get headersSelectedShard(){
    return [
      {text: this.$t('newShardList.table.name'), sortable: true, value: 'title'},
    {text: '', sortable: false, value: 'data', width: '100'},
  ]

  }

  itemsLength(length:any) {
    let response = checkContour('shardListLength', window.location.href)
    return response == 'fixed' ? 416 : length
  }

 options:any = {page:1,itemsPerPage:20,sortBy:['updatedAtTimestamp'],sortDesc:[false]}
 page:number = 1

  debouncedUpdate: any = debounce(this.updateTableOptions, 400)


  @Watch('options',{immediate: true, deep: true })
  changeOptions(newVal:any, oldVal:any){
    this.debouncedUpdate(newVal, oldVal)
  }

  async updateTableOptions(newVal:any, oldVal:any) {
    if(newVal && oldVal !== undefined){
      this.setOptionsTable(newVal)
      await this.loadShardsFromServerWithQuery()
      if(this.page != this.options.page) {
        this.page = this.options.page
        let table = document.querySelector('.v-data-table__wrapper') as HTMLElement
        table.scrollTop = 0
      }
    }
  }
  @Watch('updateFilter',{immediate: true, deep: true })
  updateFilterFun(newVal:any, oldVal:any){
    if(newVal && newVal !== undefined){
      const optionsChanges:any  = this.optionsSetting(this.options, this.GetFilterShards[9].value)
      this.setOptionsTable(optionsChanges)
      // this.options = null
      this.options = {...optionsChanges}

    }
  }

  optionsSetting(inOptions:any, storeOptions:any){
    // console.log('inOptions',inOptions)
    // console.log('storeOptions',storeOptions)
    inOptions.page = 1
    inOptions.itemsPerPage = storeOptions.itemsPerPage
    inOptions.sortBy = storeOptions.sortBy
    inOptions.sortDesc = storeOptions.sortDesc
    return inOptions

  }


  type:any = {
    person: this.$t('newShardList.table.type.person'),
    company: this.$t('newShardList.table.type.company')
  }
  query:string=''
  opacity:Number =0.5



  isArchiveFun(payload:any){
    this.$emit('isArhive',payload)
  }


  mounted() {
    // this.loadShardsFromServerWithQuery()
    if(this.plan === 'pro') {
      this.loadSurveyFromServer()
    }
  }

  timeConverter(UNIX_timestamp: any) {
    if(UNIX_timestamp == 0) return ''
    const a = new Date(UNIX_timestamp * 1000);
    const months = ['янв', 'фев', 'март', 'апр', 'май', 'июнь', 'июль', 'авг', 'сен', 'окт', 'ноя', 'дек'];
    const year = a.getFullYear();
    const month = this.dable(a.getMonth() + 1);
    const date = this.dable(a.getDate());
    const clock = this.dable(a.getHours())
    const min = this.dable(a.getMinutes())
    const rTime = clock + ':' + min
    const rDate = date + '.' + month + '.' + year;

    return {rDate, rTime};
  }

  dable(num: number) {
    return num < 10 ? '0' + num : num
  }

  clickRow(item:any) {
    if(!this.disabledTable) {
      this.$emit('selectShard', item)
    }
  }

  rowClasses(item:any) {
    return (this.isSelectedShard && item.id == this.selectedId) ? 'lfs-data-table-active' : ''
  }

  showTable() {
    this.$emit('showTable')
  }

}
